module.exports = __webpack_public_path__ + "33e69efbd887b5e24a109f83ab713cda.svg";